module.exports = "/_next/static/media/default-og-image.4c07ae17.jpg";